import React from "react";

import  IntOutBoundFileDetail from "../component/IntOutBoundFileDetail";

const IntOutBoundFileDetailContainer = () => (<IntOutBoundFileDetail />)

export default IntOutBoundFileDetailContainer;